// Statuses after which a subscription never bills or gives access again.
const ENDED_STATUSES = ['canceled', 'incomplete_expired'];

/**
 * Whether a subscription is finished for good, so a new one can replace it. Past-due,
 * unpaid and incomplete subscriptions are not: they can still be paid, and the API
 * refuses a new subscription while one is open.
 */
export function isSubscriptionEnded(subscription) {
    return ENDED_STATUSES.includes(subscription.status);
}

/**
 * Whether a subscription is still paying for access: not ended, and not past its grace
 * period. A Free company only counts as upgraded while this holds; once its paid
 * subscription ends it is back on the Free plan, not locked out.
 */
export function isSubscriptionInForce(subscription) {
    if (!subscription || isSubscriptionEnded(subscription)) return false;

    // No grace date yet means the payment webhook has not landed; the subscription is new.
    return !subscription.graceEndsAt || new Date(subscription.graceEndsAt) >= new Date();
}
